import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatExtensions",
  standalone: false
})
/** add x in front of extension numbers, except those that start with * */
export class FormatExtensionsPipe implements PipeTransform {
  transform(extensions: string | Array<string> | undefined): Array<string> {
    if (!extensions) return [];
    return (Array.isArray(extensions) ? extensions : [extensions]).map(extension =>
      String(extension)?.replace(/^(\*)?[0-9*]{2,6}$/, (fullMatch, starGroup) =>
        starGroup ? fullMatch : "x" + fullMatch
      )
    );
  }
}
